import { createAsyncThunk } from "@reduxjs/toolkit";
import { SalesTableRequestParams } from "../interface";
import { getSalesTableData } from "src/api/bi";

export const fetchSalesTableData = createAsyncThunk(
  "itemDetails/fetchSalesTableData",
  (payload: SalesTableRequestParams) => getSalesTableData(payload)
);
